/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import classNames from "classnames";

import {
  Logo,
  LogoAdvisory,
  LogoAdvisoryDark,
  LogoBaselineNL,
  LogoBaselineFR,
  LogoBaselineEN,
  NoResults,
  IconCaret,
  IconCaretFilled,
  IconCaretFilledDown,
  IconCancel,
  IconUrlLink,
  IconPhone,
  IconEmail,
  IconList,
  IconMap,
  IconLocation,
  IconFacebook,
  IconTwitter,
  IconShareLink,
  IconCalculator,
  IconPercentage,
  IconFoldedBanknote,
  IconScale,
  IconMoneyGraph,
  IconMoneyHand,
  IconBarGraph,
  IconLineGraph,
  IconDigitalProcess,
  IconHat,
  IconStreetSign,
  IconMedal,
  IconMountains,
  IconSearch,
  Check,
  Gallery,
  Filters,
  Link,
  Message,
  Settings,
  Clock,
  LogoP,
  PRect,
  YoutubeIcon,
  InstagramIcon,
  LinkedinIcon,
  TiktokIcon,
  DownloadIcon,
  Star,
} from "assets/icons";
import { IconType } from "@types";

import s from "./Icon.module.scss";

interface Props {
  name: string;
  color?: "white" | "grey" | "medium-grey" | "black" | "blue" | "faded-blue";
  size?: "xxs" | "xs" | "s" | "m" | "l" | "xl" | "xxl";
  background?: boolean;
  mirror?: boolean;
  broder?: boolean;
  rounded?: boolean;
}

export const Icon: FC<Props> = ({
  name,
  color = "black",
  size,
  background = false,
  mirror = false,
  broder = false,
  rounded = false,
}) => {
  return (
    <span
      className={classNames(s.Icon, {
        [s.HasBackground]: background,
        [s.Border]: broder,
        [s.Rounded]: rounded,
        [s.Micro]: size === "xxs",
        [s.Tiny]: size === "xs",
        [s.Small]: size === "s",
        [s.Medium]: size === "m",
        [s.Large]: size === "l",
        [s.XLarge]: size === "xl",
        [s.XxLarge]: size === "xxl",
      })}
    >
      <span
        className={classNames(s.Inner, {
          [s.Micro]: size === "xxs",
          [s.Tiny]: size === "xs",
          [s.Small]: size === "s",
          [s.Medium]: size === "m",
          [s.Large]: size === "l",
          [s.XLarge]: size === "xl",
          [s.XXLarge]: size === "xxl",
          [s.IsWhite]: color === "white",
          [s.IsGrey]: color === "grey",
          [s.IsMediumGrey]: color === "medium-grey",
          [s.IsBlack]: color === "black",
          [s.IsBlue]: color === "blue",
          [s.IsFadedBlue]: color === "faded-blue",
          [s.Mirror]: mirror === true,
        })}
      >
        {name === IconType.Logo && <Logo />}
        {name === IconType.LogoAdvisory && <LogoAdvisory />}
        {name === IconType.LogoAdvisoryDark && <LogoAdvisoryDark />}
        {name === IconType.LogoBaselineNL && <LogoBaselineNL />}
        {name === IconType.LogoBaselineFR && <LogoBaselineFR />}
        {name === IconType.LogoBaselineEN && <LogoBaselineEN />}
        {name === IconType.LogoP && <LogoP />}
        {name === IconType.NoResults && <NoResults />}
        {name === IconType.Caret && <IconCaret />}
        {name === IconType.CaretFilled && <IconCaretFilled />}
        {name === IconType.CaretFilledDown && <IconCaretFilledDown />}
        {name === IconType.Cancel && <IconCancel />}
        {name === IconType.UrlLink && <IconUrlLink />}
        {name === IconType.Phone && <IconPhone />}
        {name === IconType.Email && <IconEmail />}
        {name === IconType.List && <IconList />}
        {name === IconType.Map && <IconMap />}
        {name === IconType.Location && <IconLocation />}
        {name === IconType.Facebook && <IconFacebook />}
        {name === IconType.Twitter && <IconTwitter />}
        {name === IconType.ShareLink && <IconShareLink />}
        {name === IconType.Calculator && <IconCalculator />}
        {name === IconType.Percentage && <IconPercentage />}
        {name === IconType.FoldedBanknote && <IconFoldedBanknote />}
        {name === IconType.Scale && <IconScale />}
        {name === IconType.MoneyGraph && <IconMoneyGraph />}
        {name === IconType.MoneyHand && <IconMoneyHand />}
        {name === IconType.BarGraph && <IconBarGraph />}
        {name === IconType.LineGraph && <IconLineGraph />}
        {name === IconType.DigitalProcess && <IconDigitalProcess />}
        {name === IconType.Hat && <IconHat />}
        {name === IconType.StreetSign && <IconStreetSign />}
        {name === IconType.Medal && <IconMedal />}
        {name === IconType.Mountains && <IconMountains />}
        {name === IconType.Search && <IconSearch />}
        {name === IconType.Check && <Check />}
        {name === IconType.Gallery && <Gallery />}
        {name === IconType.Filters && <Filters />}
        {name === IconType.Link && <Link />}
        {name === IconType.Message && <Message />}
        {name === IconType.Settings && <Settings />}
        {name === IconType.Clock && <Clock />}
        {name === IconType.PRect && <PRect />}
        {name === IconType.YoutubeIcon && <YoutubeIcon />}
        {name === IconType.InstagramIcon && <InstagramIcon />}
        {name === IconType.LinkedinIcon && <LinkedinIcon />}
        {name === IconType.TiktokIcon && <TiktokIcon />}
        {name === IconType.DownloadIcon && <DownloadIcon />}
        {name === IconType.Star && <Star />}
      </span>
    </span>
  );
};
